export const extractErrorMessage = (error: any, defaultMessage = 'An error occurred'): string => {
  if (error?.response?.data) {
    const responseData = error.response.data;
    
    const message = responseData.message 
      || responseData.error?.message
      || responseData.errors?.[0]?.message
      || responseData.errors?.[0]?.displayMessage
      || (typeof responseData.errors?.[0] === 'string' ? responseData.errors[0] : null);
    
    if (message) return message;
  }
  
  if (error?.errors && Array.isArray(error.errors) && error.errors.length > 0) {
    const firstError = error.errors[0];
    
    if (typeof firstError === 'string') {
      return firstError;
    }
    
    if (firstError?.displayMessage) {
      return firstError.displayMessage;
    }
    
    if (firstError?.message) {
      return firstError.message;
    }
  }
  
  if (error?.responseObject?.message) {
    return error.responseObject.message;
  }
  
  if (error?.message && typeof error.message === 'string') {
    return error.message;
  }
  
  return defaultMessage;
};

export const extractErrorFromResponse = (response: any, defaultMessage = 'Operation failed'): string => {
  if (response?.responseObject?.message) {
    return response.responseObject.message;
  }
  
  if (response?.errors && Array.isArray(response.errors) && response.errors.length > 0) {
    const firstError = response.errors[0];
    
    if (typeof firstError === 'string') {
      return firstError;
    }
    
    if (firstError?.message) {
      return firstError.message;
    }
    
    if (firstError?.displayMessage) {
      return firstError.displayMessage;
    }
  }
  
  return defaultMessage;
};
